import React from 'react';
import classnames from 'classnames';

const Notice = ({
  animateOn,
  children,
  colour = 'dark',
  position = 'bottom',
}) => {
  const colourClass = (colour) => {
    switch (colour) {
      case 'dark':
        return 'bg-haiti';
      case 'light':
      default:
        return 'bg-white';
    }
  };

  const animateClass = classnames('duration-300 transform transition', {
    'opacity-0 scale-95': !animateOn,
    'opacity-100 scale-100': animateOn,
  });

  const wrapperClass = classnames('fixed inset-x-0 z-30', {
    'bottom-0 pb-6': position === 'bottom',
    'pt-6 top-0': position === 'top',
    [animateClass]: animateOn !== undefined,
  });

  const noticeClass = classnames(
    'px-4 py-2 rounded shadow-lg',
    colourClass(colour)
  );

  return (
    <div className={wrapperClass}>
      <div className="mx-auto max-w-screen-lg px-4">
        <div className={noticeClass}>{children}</div>
      </div>
    </div>
  );
};

export default Notice;
